// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-price{display:inline-block;font-family:var(--number-font);white-space:nowrap}.h-price__suffix-jpy{font-size:.8em}", ""]);
// Exports
module.exports = exports;
